export default __webpack_public_path__ + "static/press-awards-ExpertiseDenver-2c843f8c3f42aba604fef2cf6241cf89.jpg";